import script from "./newStaffMemberButton.vue?vue&type=script&setup=true&lang=js"
export * from "./newStaffMemberButton.vue?vue&type=script&setup=true&lang=js"

import "./newStaffMemberButton.vue?vue&type=style&index=0&id=3456e89d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3456e89d"]])

export default __exports__